import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const productConfigApi = createApi({
  reducerPath: "productConfigApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["ProductConfig"],
  endpoints: (build) => ({
    listConfigs: build.query<
      ProductConfig[],
      { companyId: number; serviceId: number; search?: string }
    >({
      query: ({ companyId, serviceId, search }) => ({
        url: `${companyId}/services/${serviceId}/product-config`,
        method: "GET",
        params: search ? { search } : undefined,
      }),
      providesTags: ["ProductConfig"],
    }),
    createConfig: build.mutation<
      ProductConfig[],
      { companyId: number; serviceId: number; data: ProductConfigData[] }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `${companyId}/services/${serviceId}/product-config`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ProductConfig"],
    }),
    editConfig: build.mutation<
      ProductConfig[],
      { companyId: number; serviceId: number; data: ProductConfigData[] }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `${companyId}/services/${serviceId}/product-config`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ProductConfig"],
    }),
  }),
});
